import React from "react";

export default function HtmlCenterContainer({
  bgColor = "white",
  children = "",
}) {
  return (
    <div
      className={`h-screen w-full flex flex-col justify-center items-stretch scroll-thumb bg-slate-300 bg-no-repeat bg-center`}
    >
      {children}
    </div>
  );
}
